import { FC, ReactNode, useContext, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

import statisticContext from 'context/statisticsContext'
import VideoBlockInfo from 'components/webinar/video-block/video-block-info'
import Recommendations from 'containers/recommendations/recommendations'
import Commentaries from 'components/parts/commentaries/commentaries'
import WriteUs from 'components/parts/write-us/write-us-popup/write-us'
import WidthLimiter from 'containers/width-limiter/width-limiter'
import BreadcrumbsPage from 'components/parts/breadcrumb-page/breadcrumb-page'
import useLectorsSubscription from 'hooks/useLectorsSubscription'
import VideoFrameMaterial from 'components/webinar/video-block/video-frame-material'

import { URL_SITE } from 'constants/data'
import { PLACEFLAG_PAST, PLACEFLAG_VIDEO } from 'constants/analytic-data'
import { originSubscribe, originFWebinar } from 'utils/analytics/webinars/webinar_future'
import { IMaterial } from 'constants/types/webinar.types'
import { SocketEvents } from 'constants/events'
import { useARegAndLogin, originReg } from 'utils/analytics/other/registration/registration'
import { A_lec_openLectures, originLectures } from 'utils/analytics/library/lectures'
import { A_wp_openWebinar, originPWebinar } from 'utils/analytics/webinars/webinar_past'
import { getPlayerMethods } from 'components/webinar/video-block/utils'
import { originArticle } from 'utils/analytics/library/article'
import { originShare } from 'utils/analytics/other/share_material/share_material'

import styles from './../articles.module.scss'
import stylesVideo from './article-video.module.scss'
import videoMaterialStyle from 'styles/common/common-material.module.scss'

interface IArticleVideo {
  dataset: IMaterial
  isWebinar?: boolean
  isWithFormat?: boolean
  children?: ReactNode
}

const ArticleVideo: FC<IArticleVideo> = (props: IArticleVideo) => {
  const [toggleFeedback, setToggleFeedback] = useState(false)
  const { dataset, isWebinar, isWithFormat, children } = props
  const place = isWebinar ? PLACEFLAG_PAST : PLACEFLAG_VIDEO
  const lectorsData = useLectorsSubscription(dataset.Lecturs, place)
  const refPlayer = useRef<any>(null)
  const isMustBePaid = dataset?.isAcceptAllow === false //Именно false, а не undefined, например
  const socket = useContext(statisticContext)

  const handleToggleFeedback = () => setToggleFeedback((prevValue) => !prevValue)
  const handleTimeCode = (time: number) => getPlayerMethods(time, dataset.videoLink, refPlayer)

  useARegAndLogin(isWebinar ? originReg.WEBINAR_PAST : originReg.VIDEO)

  const ADataObj = isWebinar
    ? {
        originSub: originSubscribe.WEBINAR_PAST,
        originClick: originFWebinar.WEBINAR_PAST,
      }
    : {
        originForArticle: originArticle.RECOMENDATION,
      }

  useEffect(() => {
    if (isWebinar && socket?.sendEvent) socket?.sendEvent(SocketEvents.WEBINAR_RECORD)
  }, [socket])

  useEffect(() => {
    if (isWebinar) {
      A_wp_openWebinar(originPWebinar.NOORIGIN, dataset.id)
    } else {
      A_lec_openLectures(originLectures.NOORIGIN, dataset.id)
    }
  }, [dataset.id, isWebinar])

  return (
    <div
      className={clsx(videoMaterialStyle.twoColumn, {
        [videoMaterialStyle.oneColumn]: dataset.isHideRecommendations,
      })}
    >
      <WriteUs toggleFeedback={toggleFeedback} setToggleFeedback={handleToggleFeedback} />
      <div className={clsx(styles.articleWrapper, styles.notTopMargin)}>
        {isWithFormat && (
          <section
            className={clsx(styles.recomendationSection, styles.recomendationSectionVertical)}
          >
            <WidthLimiter noTopPadding noBottomPadding noLeftPadding noRightPadding>
              <div>{children}</div>
            </WidthLimiter>
          </section>
        )}
        <WidthLimiter noTopPadding noBottomPadding noLeftPadding noRightPadding>
          <div className={stylesVideo.whiteBgVideo}>
            <main>
              <div className={stylesVideo.breadcrumb}>
                <BreadcrumbsPage
                  breadData={[
                    {
                      name: isWebinar ? 'Вебинары' : 'Библиотека',
                      link: isWebinar ? `${URL_SITE}/webinar` : `${URL_SITE}/library`,
                    },
                    { name: dataset.name, link: '' },
                  ]}
                ></BreadcrumbsPage>
              </div>
              <VideoFrameMaterial dataset={dataset} refPlayerOuter={refPlayer} />
              <VideoBlockInfo
                dataset={dataset}
                lectorsData={lectorsData}
                isMustBePaid={isMustBePaid}
                isEnded
                handleTimeCode={handleTimeCode}
                origin={isWebinar ? originShare.WEBINAR_PAST : originShare.VIDEO}
              />
            </main>
          </div>

          {!dataset.isHideComments && (
            <div className={videoMaterialStyle.commentaries}>
              <Commentaries
                comments={dataset.Comments}
                id={dataset.id}
                materialType={isWebinar ? 'webinar' : 'article'}
                isWithNMO={Boolean(dataset.activeNMOCodes)}
                isAllowComment={dataset?.isAcceptAllow}
              />
            </div>
          )}
        </WidthLimiter>
      </div>
      {!dataset.isHideRecommendations && (
        <div className={stylesVideo.recommendWrapper}>
          <Recommendations
            isVerticalMobile
            isVertical
            noMargin
            noPadding
            eventWrapperModificator={videoMaterialStyle.eventWrapperModificator}
            cardModificator={videoMaterialStyle.cardModificator}
            AData={ADataObj}
          />
        </div>
      )}
    </div>
  )
}

export default ArticleVideo
